import React, { memo, useCallback } from 'react';
import useInAppBrowser from '../../hooks/useInAppBrowser';
import * as styles from './SmallLinksBar.module.scss';
import { isDisclaimerPlatform } from '../../lib/platform';

const SmallLinkButton = ({
  url,
  platform,
  creatorName,
  disableDeeplinks = false,
  backgroundColor,
  children,
}) => {
  const shouldForceExternalBrowser =
    !disableDeeplinks && isDisclaimerPlatform(platform);

  const { handleLinkClick } = useInAppBrowser({
    creatorName,
    preferInAppBrowser: !shouldForceExternalBrowser,
  });

  const onLinkClick = useCallback(
    (e) => {
      e.preventDefault();
      handleLinkClick(url);
    },
    [handleLinkClick, url]
  );

  return (
    <a
      className={styles.iconButton}
      href={url}
      target="_blank"
      rel="noreferrer"
      onClick={onLinkClick}
      style={{ backgroundColor }}
      aria-label={platform}
    >
      <span className={styles.iconWrapper}>{children}</span>
    </a>
  );
};

export default memo(SmallLinkButton);
